import React from 'react';
import { Link } from 'react-router-dom';
import graduationImg from "../../assests/graduation_image.jpg";
import prayerImg from "../../assests/dand.jpg";
import seminaryGroupImg from "../../assests/gang.jpg";

function TrainingNationals() {
  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        background: "#fff",
        color: "#333",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "0 1.5rem 3rem",
        }}
      >
        {/* Back */}
        <Link
          to="/"
          style={{
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            fontSize: "13px",
            marginTop: "1.5rem",
          }}
        >
          ← Back to Home
        </Link>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            color: "#ef7d32",
            fontSize: "2.8rem",
            marginBottom: ".3rem",
          }}
        >
          Training Nationals as Pastors and Evangelists
        </h1>

        {/* Dots */}
        <div
          style={{
            display: "flex",
            gap: 4,
            marginBottom: "2rem",
          }}
        >
          {[...Array(10)].map((_, i) => (
            <span
              key={i}
              style={{
                width: 5,
                height: 5,
                borderRadius: "50%",
                background: "#ef7d32",
              }}
            />
          ))}
        </div>

        {/* Top Section */}
        <div
          style={{
            display: "flex",
            gap: "2rem",
            flexWrap: "wrap",
            alignItems: "flex-start",
            marginBottom: "2rem",
          }}
        >
          <img
            src={graduationImg}
            alt="Graduation"
            style={{
              width: "340px",
              height: "220px",
              objectFit: "cover",
              borderRadius: 4,
            }}
          />

          <div
            style={{
              flex: 1,
              minWidth: "250px",
            }}
          >
            <p
              style={{
                fontSize: "13px",
                lineHeight: 1.8,
              }}
            >
              Our COTR Theological Seminary opened in 1983 with 30 students.
              Now, more than 4,000 students have graduated over the past 40
              years.
            </p>

            <strong>This seminary offers:</strong>

            <ul
              style={{
                marginTop: "10px",
                paddingLeft: "18px",
                lineHeight: "1.8",
                fontSize: "13px",
              }}
            >
              <li>Bachelor's in Theology</li>
              <li>Master of Divinity</li>
              <li>Master's in Theology, in Missiology</li>
              <li>History of Christianity</li>
              <li>Doctoral Program in Missiology</li>
              <li>Global Online External Study Program</li>
            </ul>

            <p
              style={{
                fontSize: "13px",
                lineHeight: 1.8,
              }}
            >
              The library serves as the primary resource for academicians,
              aspiring evangelists, missionaries, pastors and other Indian
              gospel workers.
            </p>

            <p
              style={{
                fontSize: "13px",
                lineHeight: 1.8,
              }}
            >
              The library has a current collection of 44,000 books.
            </p>
          </div>
        </div>

        {/* Bottom Images */}
        <div
          style={{
            display: "flex",
            gap: "1rem",
            flexWrap: "wrap",
          }}
        >
          <img
            src={prayerImg}
            alt="Prayer"
            style={{
              flex: 1,
              minWidth: "300px",
              height: "220px",
              objectFit: "cover",
              borderRadius: 4,
            }}
          />

          <img
            src={seminaryGroupImg}
            alt="Seminary"
            style={{
              flex: 1,
              minWidth: "300px",
              height: "220px",
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
        </div>
      </div>

      {/* Support Section */}
      <div
        style={{
          background: "#2f8b57",
          color: "#fff",
          textAlign: "center",
          padding: "40px 20px",
        }}
      >
        <p
          style={{
            margin: "0 0 25px",
            fontSize: "15px",
          }}
        >
          To sponsor a seminary student, you can give $50 monthly.
        </p>

        {/* PayPal Donation Link */}
        <a
          href="https://www.paypal.com/donate/?hosted_button_id=VKA8FX7X6AJG2"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            display: "inline-block",
          }}
        >
          <button
            type="button"
            style={{
              background: "#fff",
              color: "#2f8b57",
              border: "none",
              padding: "12px 35px",
              fontWeight: "bold",
              cursor: "pointer",
              borderRadius: 3,
            }}
          >
            GIVE
          </button>
        </a>
      </div>
    </div>
  );
}

export default TrainingNationals;
